import ReactDOM from 'react-dom/client';
import FontFaces from 'styles/FontFaces';
import GlobalStyles from 'styles/GlobalStyles';
import { Provider } from 'mobx-react';
import { addLocale, locale } from 'primereact/api';
import localeOptions from 'utils/locale';
import * as Sentry from '@sentry/react';
import store from './store';
import App from './App';
import 'primereact/resources/themes/lara-light-indigo/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';
import 'styles/CustomTheme.css';

if (process.env.NODE_ENV === 'production') {
  Sentry.init({
    dsn: 'https://0ff8c4a9bd894662844bbd1e07e6aa2a@sentry.siberian.pro/15',
    integrations: [new Sentry.BrowserTracing()],
    tracesSampleRate: 1.0,
  });
}

addLocale('ru', localeOptions);
locale('ru');
const root = ReactDOM.createRoot(document.getElementById('root') as Element);
root.render(
  <>
    <GlobalStyles />
    <FontFaces />
    <Provider rootStore={store}>
      <App />
    </Provider>
  </>,
);
